import { createApp} from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import { loadFonts } from './plugins/webfontloader'
import axios from 'axios'
import VueAxios from 'vue-axios'

loadFonts()



createApp(App)
  .use(router)
  .use(vuetify)
  .use(VueAxios, axios)
  .mount('#app')

  let backend

if (window.location.hostname === "localhost") {
  backend = 'http://localhost:3001/rest'
} else if (window.location.hostname === "onlineapplication.ocp.standardbank.co.za") {
  backend = '/rest'
} else if (window.location.hostname === "onlineapplication.dinersclub.co.za") {
  backend = '/rest'
} else if (window.location.hostname === "online-application-web-stage.apps.tc001745-dev.afs1-nprd.aws-za.sbgrp.cloud") {
  backend = '/stagesit'
} else if (window.location.hostname === "online-application-web-stable.apps.tc001745-dev.afs1-nprd.aws-za.sbgrp.cloud") {
  backend = '/stablesit'
} else if (window.location.hostname === "onlineapplicationsit.dinersclub.co.za") {
  backend = '/stablesit'
} else if (window.location.hostname === "online-application-web-stage.apps.tc01745-app.afs1-prd.aws-za.sbgrp.cloud") {
  backend = '/stageprod'
} else if (window.location.hostname === "online-application-web-stable.apps.tc01745-app.afs1-prd.aws-za.sbgrp.cloud") {
  backend = '/stableprod'
}

axios.defaults.method = 'POST'
axios.defaults.baseURL = backend
if (window.location.hostname !== "localhost") {
  axios.defaults.headers.common['X-Frame-Options'] = 'DENY'
}
